const store = new Vuex.Store({
    state: {
        menustatus:0
    },
    mutations: {
        menuzero(state){
            state.menustatus = 0
        },
        menuone(state){
            state.menustatus = 1
        }
    },
    getters:{
        menustatus:state=>{
            return state.menustatus
        }
    }
})

export default store


// WEBPACK FOOTER //
// ./src/vuex/index.js